import { render, staticRenderFns } from "./sihuang-form.html?vue&type=template&id=ca492af8&scoped=true&external"
import script from "./sihuang-form.js?vue&type=script&lang=js&external"
export * from "./sihuang-form.js?vue&type=script&lang=js&external"
import style0 from "./sihuang-form.scss?vue&type=style&index=0&id=ca492af8&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca492af8",
  null
  
)

export default component.exports